<template>
  <div class="foot">
    <div class="container">
      <el-row :gutter="30">
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" style="margin-right: 50px;margin-bottom: 20px;">
          <div class="foot-header">关于我们<br /></div>
          <div class="foot-about">河北国超信息科技有限公司以汽车技术研发为主，经营业务包括汽车用户手册编写与开发，汽车维修手册、汽车工时手册，汽车电路图册、汽车故障诊断手册等各类产品手册企划、编写、开发和各语种翻译汽车各语种维修可视化光盘、拍摄开发，汽车各语种用户可视化培训光盘的拍摄开发。汽车备品图册的设计绘画开发或汽车销售、竞品对比，新车上市，会议运营等业务标准化的支援和技术培训。</div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" style="margin-bottom: 20px;">
          <div class="foot-header">合作伙伴<br /></div>
          <div class="foot-cooper">
            <div>
              <el-link icon="el-icon-d-arrow-right">日本CMC株式会社</el-link>
            </div>
            <div>
              <el-link icon="el-icon-d-arrow-right">天津国超软件技术有限公司</el-link>
            </div>
            <div>
              <el-link icon="el-icon-d-arrow-right">广州国超森茂森信息科技有限公司</el-link>
            </div>
            <div>
              <el-link icon="el-icon-d-arrow-right">辛集市国超职业培训学校</el-link>
            </div>
            <div>
              <el-link icon="el-icon-d-arrow-right">河北科技大学</el-link>
            </div>
            <div>
              <el-link icon="el-icon-d-arrow-right">河北师范大学</el-link>
            </div>
            <div>
              <el-link icon="el-icon-d-arrow-right">河北经贸大学</el-link>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" style="margin-bottom: 20px;">
          <div class="foot-header">联系方式<br /></div>
          <div class="foot-contact">
            <div>
              <el-link icon="el-icon-d-arrow-right" @click="open1">河北国超信息科技有限公司</el-link>
            </div>
            <div>
              <el-link icon="el-icon-d-arrow-right" @click="open2">广州国超森茂森信息科技有限公司</el-link>
            </div>
            <div>
              <el-link icon="el-icon-d-arrow-right" @click="open3">广州国超森茂森信息科技有限公司北京分公司</el-link>
            </div>
            <div>
              <el-link icon="el-icon-d-arrow-right" @click="open5">芜湖分公司</el-link>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" style="margin-bottom: 20px;">
          <div class="foot-header">服务标签<br /></div>
          <div class="tags">
            <el-button type="primary">汽车售后技术资料开发</el-button>
            <el-button type="primary">汽车使用说明书</el-button>
            <el-button type="primary">产品说明书编写开发</el-button>
            <el-button type="primary">汽车电路图册开发</el-button>
               <el-button type="primary">备品目录</el-button>
            <el-button type="primary">手册排版</el-button>
            <el-button type="primary">机械图绘制</el-button>
            <el-button type="primary">渲染图制作</el-button>
            <el-button type="primary">多国语言翻译</el-button>
            <el-button type="primary">汽车售前</el-button>
            <el-button type="primary">售后技术培训</el-button>
            <el-button type="primary">会议运营</el-button>
            <el-button type="primary">视频拍摄</el-button>
            <el-button type="primary">动画制作</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      open1() {
        this.$alert('<div><h3>河北国超信息科技有限公司</h3></div>' +
          '<div>地址：河北省辛集市龙泉街西段9号</div>' + '<div>电话：（0311）83308230</div>' + '<div>传真：（0311）83308230</div>' +
          '<div>Emai：caoyanshuang@xjguochao.com</div>', '', {
            dangerouslyUseHTMLString: true
          });
      },
      open2() {
        this.$alert('<div><h3>广州国超森茂森信息科技有限公司</h3></div>' +
          '<div>地址：广东省广州市天河区体育西路109号高盛大厦8楼B1室</div>' + '<div>电话：020-2883-5088(总机)</div>' +
          '<div>电话： +86-020-8981-1917</div>' + '<div>传真： +86-020-8981-1443</div>', '', {
            dangerouslyUseHTMLString: true
          });
      },
      open3() {
        this.$alert('<div><h3>广州国超森茂森信息科技有限公司北京分公司</h3></div>' +
          '<div>地址：北京市朝阳区东大桥路8号 尚都国际中心2106室</div>' + '<div>电话： 010-5870-0450  010-5870-0450' +
          '<div>传真： 010-5870-0390</div>' + '<div>邮件：lilangou@gcmc.net.cn</div>', '', {
            dangerouslyUseHTMLString: true
          });
      },
      open4() {
        this.$alert('<div><h3>天津分公司</h3></div>' +
          '<div>地址：天津市西青区宾水西道399号天津工业大学天津市大学软件学院D座513室</div>' + '<div>电话： 13902038907 ' +
          '<div>邮件：guochao@guochao.net</div>', '', {
            dangerouslyUseHTMLString: true
          });
      },
      open5() {
        this.$alert('<div><h3>芜湖分公司</h3></div>' +
          '<div>地址：芜湖经济技术开发区科创中心A园508</div>' + '<div>电话： 15178537702 ', '', {
            dangerouslyUseHTMLString: true
          });
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue